import React, { useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import { CssBaseline } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";

import { GlobalThemeProvider } from "./context/GlobalTheme";
import { i18n } from "./translate/i18n";
import Routes from "./routes";
import DefaultFunctionsUtils from "./utils/classes/DefaultFunctionsUtils";
import ServiceWorkerUpdateToast from "./components/ServiceWorkerUpdateToast";

const App = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const serviceWorkerUpdateToastIdRef = useRef(null);



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    // ***---- Theme ----***
    if (localStorage.getItem("theme") === null) {
      localStorage.setItem("theme", "light");
      document.getElementById("root").style.background = "#eeeee4";
      document.getElementById("root").style.color = "#000000";
      document.body.style.background = "#eeeee4";
    }
    else {
      document.body.style.background = localStorage.getItem("theme") === "dark" ? "#2c2f33" : "#eeeee4";
      document.getElementById("root").style.color = localStorage.getItem("theme") === "dark" ? "#eeeee4" : "#000000";
      document.getElementById("root").style.background = localStorage.getItem("theme") === "dark" ? "#2c2f33" : "#eeeee4";
    }

    // ***---- Menu ----***
    if (localStorage.getItem("selectedIndexRoute") === null) localStorage.setItem("selectedIndexRoute", DefaultFunctionsUtils.getSelectedIndexRouteByPath());
    if (localStorage.getItem("isMainMenuOpen") === null) localStorage.setItem("isMainMenuOpen", "1");

    // ***---- Tabs ----***
    if (localStorage.getItem("tabOpenTickets") === null) localStorage.setItem("tabOpenTickets", "open");
    if (localStorage.getItem("tabOpenSettings") === null) localStorage.setItem("tabOpenSettings", "general");

    // ***---- Settings ----***
    if (localStorage.getItem("flagNotificationSound") === null) localStorage.setItem("flagNotificationSound", "true");
    if (localStorage.getItem("showAllTickets") === null) localStorage.setItem("showAllTickets", "0");
    if (localStorage.getItem("latestNews") === null) localStorage.setItem("latestNews", "none");
    
    // ***---- Views ----***
    if (localStorage.getItem("contactsViewLayout") === null) localStorage.setItem("contactsViewLayout", "list");
    if (localStorage.getItem("contactsViewType") === null) localStorage.setItem("contactsViewType", "0");
    if (localStorage.getItem("usersViewLayout") === null) localStorage.setItem("usersViewLayout", "list");
    if (localStorage.getItem("usersViewType") === null) localStorage.setItem("usersViewType", "0");

    // ***---- Current Playing Audio ----***
    if (localStorage.getItem("currentPlayingAudio") === null) localStorage.setItem("currentPlayingAudio", "");
    if (localStorage.getItem("currentPlayingAudioTime") === null) localStorage.setItem("currentPlayingAudioTime", "");
    if (localStorage.getItem("currentPlayingAudioTicketId") === null) localStorage.setItem("currentPlayingAudioTicketId", "");
    if (localStorage.getItem("currentPlayingAudioContactProfilePic") === null) localStorage.setItem("currentPlayingAudioContactProfilePic", "");
    if (localStorage.getItem("currentPlayingAudioContactName") === null) localStorage.setItem("currentPlayingAudioContactName", "");
    if (localStorage.getItem("currentPlayingAudioContactId") === null) localStorage.setItem("currentPlayingAudioContactId", "");

    // ***---- Selected Ticket - Contact Id ----***
    if (localStorage.getItem("selectedTicketContactId") === null) localStorage.setItem("selectedTicketContactId", "-1");

    // ***---- Merge Messages From Different Connections ----***
    if (localStorage.getItem("mergeMessagesFromDifferentConnections") === null) localStorage.setItem("mergeMessagesFromDifferentConnections", JSON.stringify([]));

    // ***---- JSON Lists ----***
    if (localStorage.getItem("jsonBanks") === null) localStorage.setItem("jsonBanks", JSON.stringify([]));
    if (localStorage.getItem("jsonBanksVersion") === null) localStorage.setItem("jsonBanksVersion", "0.0");

    // ***---- Service Worker ----***
    const handleServiceWorkerUpdate = () => {
      if (serviceWorkerUpdateToastIdRef.current) return;

      serviceWorkerUpdateToastIdRef.current = toast.info(
        (props) => <ServiceWorkerUpdateToast {...props} />
        , { autoClose: false, closeButton: false, closeOnClick: false, draggable: false }
      );
    };

    const handleLanguageChange = () => {
      if (serviceWorkerUpdateToastIdRef.current) {
        toast.update(serviceWorkerUpdateToastIdRef.current, {
          render: (props) => <ServiceWorkerUpdateToast { ...props } />
        });
      }
    };

    window.addEventListener("serviceWorkerUpdate", handleServiceWorkerUpdate);
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      window.removeEventListener("serviceWorkerUpdate", handleServiceWorkerUpdate);
      i18n.off("languageChanged", handleLanguageChange);
    }
  }, []);



  //  ************
  //  ** Return **
  //  ************
  return (
    <GlobalThemeProvider>
      <ToastContainer autoClose={5000} draggable theme={"light"} />
      <Routes />
      <CssBaseline />
    </GlobalThemeProvider>
  );
};

export default App;
